var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{staticClass:"room-picker",attrs:{"items":_vm.rooms,"item-text":"name","item-value":"id","value":_vm.currentRoom,"solo":"","hide-details":"","background-color":"var(--blue-4)"},on:{"input":_vm.switchRooms}})}
var staticRenderFns = []

export { render, staticRenderFns }